import 'css-chunksrc/client/scenes/planzoneResourceRemoval/styles.scss';export default {
  "planzoneResourceRemoval": "_planzoneResourceRemoval_l4kys_1",
  "header": "_header_l4kys_6",
  "group": "_group_l4kys_10",
  "text": "_text_l4kys_14",
  "main": "_main_l4kys_19",
  "buttons": "_buttons_l4kys_26"
};